<template>
  <button
    @click="$emit('click')"
    class="w-full flex items-center space-x-3 px-4 py-2 text-left transition-colors"
    :class="buttonClasses"
  >
    <component
      :is="icon"
      class="w-5 h-5 flex-shrink-0"
      :class="iconClasses"
    />
    <span class="text-sm font-medium">{{ label }}</span>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  icon: {
    type: Object,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'danger'].includes(value)
  }
})

defineEmits(['click'])

const buttonClasses = computed(() => {
  const base = 'w-full flex items-center space-x-3 px-4 py-2 text-left transition-colors'

  if (props.variant === 'danger') {
    return `${base} text-red-700 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20`
  }

  return `${base} text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700`
})

const iconClasses = computed(() => {
  if (props.variant === 'danger') {
    return 'text-red-500 dark:text-red-400'
  }

  return 'text-gray-400 dark:text-gray-500'
})
</script>